import React, { useEffect, useState } from 'react';
import AdminApi from './AdminApi';

const AdminSettingPage = ({ currentMenu, clickChangeMenu }) => {
    const [settings, setSettings] = useState([]);
    const [groups, setGroups] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        Promise.all([AdminApi.getSettings(), AdminApi.getSettingGroups()])
            .then(([settingsData, groupsData]) => {
                setSettings(settingsData);
                setGroups(groupsData);
            })
            .catch(err => console.error("Error fetching settings:", err))
            .finally(() => setIsLoading(false));
    }, []);

    const getGroupName = (groupId) => {
        const group = groups.find(g => g.id === groupId);
        return group ? group.name : 'Unknown';
    };

    return (
        <div className="social-box" style={{ padding: '20px', backgroundColor: 'white', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)', margin: '15px' }}>
            <h3 className="page-title" style={{ marginBottom: '20px', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>Quản lý Tùy chỉnh</h3>
            <div className="header">
                <div className="btn-group">
                    <a className="btn btn-primary" href="#" onClick={e => e.preventDefault()}>
                        <i className="icon-plus" /> Thêm tùy chỉnh
                    </a>
                </div>
            </div>
            <div className="body" style={{ marginTop: '20px' }}>
                <table className="table table-hover table-striped">
                    <thead>
                        <tr style={{ backgroundColor: '#fcfcfc' }}>
                            <th>Tên</th>
                            <th>Mã (Code)</th>
                            <th>Giá trị</th>
                            <th>Nhóm</th>
                            <th>Thứ tự</th>
                            <th>Kích hoạt</th>
                            <th width="150px">Thao tác</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading ? (
                            <tr><td colSpan="7 text-center">Đang tải...</td></tr>
                        ) : (
                            settings.map((item) => (
                                <tr key={item.id}>
                                    <td><strong>{item.name}</strong></td>
                                    <td><code>{item.code}</code></td>
                                    <td>{item.value}</td>
                                    <td>{getGroupName(item.group)}</td>
                                    <td>{item.order}</td>
                                    <td>
                                        <input type="checkbox" checked={item.active} readOnly />
                                    </td>
                                    <td>
                                        <a className="btn btn-success btn-small" href="#" onClick={e => e.preventDefault()}>
                                            <i className="coloredicon page-white-edit" /> Sửa
                                        </a>
                                        <a className="btn btn-danger btn-small" href="#" onClick={e => e.preventDefault()}>
                                            <i className="coloredicon delete" /> Xóa
                                        </a>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AdminSettingPage;
